import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [mfaEnforced, setMfaEnforced] = useState(false);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setMfaEnforced(data.mfa_enforced);
    } catch (e) {
      if (e.response?.status === 401) {
        try {
          await api.post("/auth/refresh");
          const { data } = await api.get("/auth/me");
          setUser(data.user);
          return;
        } catch (e2) { /* fallthrough */ }
      }
      setUser(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const onLogout = () => setUser(false);
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, [reload]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };

  return <Ctx.Provider value={{ user, setUser, logout, reload, mfaEnforced }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
